const setInvestorProfileSource = (path, label) => (dispatch) => dispatch({
    type: 'INVESTOR_PROFILE_SET',
    data: { path, label },
});

export default setInvestorProfileSource;
